module.exports = __webpack_public_path__ + "static/media/Infosys.fb55d098.svg";